<template>
    <div id="achievement-codes-manage" v-if="achievementCodes">
        <div class="achievement-codes-header">
            <span>BROJ</span>
            <span>KOD</span>
            <span>BODOVI</span>
            <span>OPIS</span>
            <span>AKTIVAN</span>
        </div>
        <div class="achievement-code" v-for="(achievementCode, index) in achievementCodes" v-bind:key="achievementCode.id">
            <span>{{index+1}}.</span>
            <span>{{achievementCode.code}}</span>
            <span>{{achievementCode.pointsForCode}}</span>
            <span>{{achievementCode.description}}</span>
            <span>{{achievementCode.isActive}}</span>
            <button type="button" v-on:click="regenerateAchievementCode(achievementCode)">REGENERIRAJ</button>
            <button type="button" v-on:click="openAddEditModal(achievementCode)">UREDI</button>
            <button type="button" v-on:click="deleteAchievementCode(achievementCode)">IZBRIŠI</button>
        </div>
        <button type="button" v-on:click="openAddEditModal()">DODAJ</button>
        <AddEditAchievementCodeModal v-if="modalVisible" v-on:cancel="resetAchievementCode" v-on:save="saveAchievementCode" v-bind:achievementCode="achievementCodeForModal"/>
    </div>
</template>

<script>
    import AddEditAchievementCodeModal from '@/components/admin/achievementCodes/AddEditAchievementCodeModal.vue';

    export default {
        name: 'AchievementCodeManage',
        data() {
            return {
                achievementCodes: [],
                achievementCodeForModal: {},
                modalVisible: false
            }
        },
        components: {
            AddEditAchievementCodeModal
        },
        methods: {
            openAddEditModal: function (achievementCode) {
                this.achievementCodeForModal = achievementCode ? achievementCode : {};
                this.modalVisible = true;
            },
            saveAchievementCode: function (achievementCodeToSave) {
                if(achievementCodeToSave.id)
                    this.$axios.post(`${this.$API_URL}/achievements/code/edit`, achievementCodeToSave
                    ).catch(() => {
                        this.$axios.get(`${this.$API_URL}/achievements/code/${achievementCodeToSave.id}`).then(response => {
                            this.achievementCodes.splice(this.achievementCodes.findIndex(achievementCode => achievementCode.id === achievementCodeToSave.id), 1, response.data);
                            alert('Edit koda neuspješan. Nevaljan unos ili zabranjen pristup.');
                        }).catch(() => {
                            alert('Pokušan je edit nepostojećeg koda!');
                        });
                    });
                else
                    this.$axios.post(`${this.$API_URL}/achievements/code/add`, achievementCodeToSave
                    ).then(response => {
                        achievementCodeToSave.id = response.data.item1;
                        achievementCodeToSave.code = response.data.item2;
                        this.achievementCodes.push(achievementCodeToSave);
                    }).catch(() => {
                        alert('Dodavanje koda neuspješno. Dupli unos (ime) ili zabranjen pristup.');
                    });
                this.modalVisible = false;
            },
            resetAchievementCode: function (achievementCodeToReset) {
                if(achievementCodeToReset.id)
                    this.$axios.get(`${this.$API_URL}/achievements/code/${achievementCodeToReset.id}`).then(response => {
                        this.achievementCodes.splice(this.achievementCodes.findIndex(achievementCode => achievementCode.id === achievementCodeToReset.id), 1, response.data); });
                this.modalVisible = false;
            },
            deleteAchievementCode: function (achievementCodeToDelete) {
                if(confirm(`Jeste li sigurni da želite izbrisati kod ${achievementCodeToDelete.description}?`))
                    this.$axios.delete(`${this.$API_URL}/achievements/code/delete/${achievementCodeToDelete.id}`).then(() => {
                        this.achievementCodes.splice(this.achievementCodes.findIndex(achievementCode => achievementCode.id === achievementCodeToDelete.id), 1);
                    }).catch(() => {
                        alert("Brisanje neuspješno. Nevaljan unos ili zabranjen pristup.");
                    });
            },
            regenerateAchievementCode: function(achievementCodeToRegenerate) {
                this.$axios.post(`${this.$API_URL}/achievements/code/regenerate`, { achievementCodeId: achievementCodeToRegenerate.id }
                    ).then(response => {
                        achievementCodeToRegenerate.code = response.data;
                        alert('Ponovno generiranje koda uspješno.');
                    }).catch(() => {
                        alert('Regeneriranje koda nije uspjelo. Pokušaj ponovo.');
                    });
            }
        },
        created() {
            this.$axios.get(`${this.$API_URL}/achievements/code/all-codes`).then(response => {
                this.achievementCodes = response.data;
            });
        }
    }
</script>

<style scoped>
    .achievement-codes-header span,
    .achievement-code span {
        word-wrap: break-word;
        display: inline-block;
        height: auto;
        width: 15%;
        margin-right: 5px;
        vertical-align: center;
    }

    span:nth-child(1) {
        width: 5%;
    }

    button {
        padding: 6px;
    }

    #code-print {
        display: none;
    }
</style>